import { CommonModule } from '@angular/common';
import { Component, computed, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgxGaugeModule } from 'ngx-gauge';
import { BreakpointObserver } from '@angular/cdk/layout';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { RouterModule } from '@angular/router';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

@Component({
  selector: 'web-promo-shared-pattern-lib-product-tire-card',
  standalone: true,
  imports: [CommonModule, NgxGaugeModule, MatButtonModule, MatIconModule, RouterModule],
  templateUrl: './lib-product-tire-card.component.html',
  styleUrl: './lib-product-tire-card.component.scss',
})
export class LibProductTireCardComponent implements OnInit {
  @Input() set data(value: any) {
    this.loggingService.log('||| LibProductTireCardComponent :: =>', value);
    this.dataSignal.set(value);
  }

  // FIXME: This is a boolean
  @Input() set productType(value: any) {
    this.loggingService.log('||| productType :: =>', value);
    this.productTypeSignal.set(value);
  }

  @Input() categoryId = '1'; // Default category ID

  @Output() emitProductId = new EventEmitter();
  @Output() emitComparison = new EventEmitter();

  private readonly loggingService = inject(LoggingService);
  private observer = inject(BreakpointObserver);
  public readonly replaceBucket = new ReplaceBucket();

  dataSignal = signal<any>(undefined);
  productTypeSignal = signal<boolean>(true);

  gaugeType: 'full' | 'semi' | 'arch' = 'semi';
  gaugeValue = 0;
  isMobileView = false;
  gaugeSize = signal(100);
  gaugeThick = computed(() => (this.gaugeSize() <= 50 ? 8 : 15));

  // Computed property to generate the product detail route
  getProductDetailRoute = (productId: number | string) => {
    return `/products/${this.categoryId}/detail/${productId}`;
  };

  ngOnInit(): void {
    this.loggingService.log('Mobile? ngOnInit');
    this.observer.observe('(max-width: 600px)').subscribe((res) => {
      this.isMobileView = res.matches;
      this.loggingService.log('Mobile?', this.isMobileView);
      if (this.isMobileView) {
        this.gaugeSize.set(50);
      } else {
        this.gaugeSize.set(100);
      }
    });
  }

  productTireList = signal<any>({
    rows: [
      {
        id: 45,
        name: 'AS-1',
        badge: 'hot',
        price: 2950,
        short_description:
          'ร่องรีดน้ำขนาดใหญ่ที่แตกต่างกันบริเวณหน้ายาง ช่วยระบายน้ำออกจากหน้ายางได้อย่างรวดเร็วและมีประสิทธิภาพ พร้อมด้วยร่องรีดน้ำขนาดเล็กที่ช่วยระบายน้ำออกจากร่องรีดน้ำหลัก เพื่อการยึดเกาะบนพื้นถนนเปียกเป็นไปอย่างดีเยี่ยมและปลอดภัย',
        product_model: 'AS-1',
        content:
          '<div>\r\r\n<figure>\r\r\n  <img src="https://img5.pic.in.th/file/secure-sv1/Mask-group.png" alt="ภาพตัวอย่าง">\r\r\n  <figcaption>\r\r\n    <h2>Proxes TR1 ยาง Sporty Ultra สมรรถนะสูงรุ่นใหม่ล่าสุด</h2>\r\r\n    <p>ที่นำเอา 2 สุดยอดยางสายพันธุ์สปอร์ต มารวมตัวกัน ด้วยเอกลักษณ์ลายดอกยางแบบไม่สมมาตรจากยาง Proxes Sport และ ลายดอกยางแบบ V-Shape Design จาก Proxes T1R มาออกแบบร่วมกันเป็นดอกลายดอกยางแบบไม่สมมาตรที่เป็นเอกลักษณ์โฉบเฉี่ยวไม่ซ้ำใคร เพื่อการควบคุมที่สมบูรณ์แบบบนทุกพื้นผิว \r\r\nและครั้งแรกของยางรถยนต์กับเทคโนโลยี\r\r\nTIRE WEAR INDICATOR ที่สามารถเช็คได้ว่าเมื่อไหร่ถึงเวลา\r\r\nที่ควรเปลี่ยนยางรถยนต์ครั้งต่อไป</p>\r\r\n  </figcaption>\r\r\n</figure>\r\r\n</div>\r\r\n\r\r\n<div>\r\r\n<figure>\r\r\n  <img src="https://img2.pic.in.th/pic/Mask-group-154e25673e8c6c879.png" alt="ภาพตัวอย่าง">\r\r\n  <figcaption>\r\r\n    <h2>Proxes TR1 ยาง Sporty Ultra สมรรถนะสูงรุ่นใหม่ล่าสุด</h2>\r\r\n    <p>ที่นำเอา 2 สุดยอดยางสายพันธุ์สปอร์ต มารวมตัวกัน ด้วยเอกลักษณ์ลายดอกยางแบบไม่สมมาตรจากยาง Proxes Sport และ ลายดอกยางแบบ V-Shape Design จาก Proxes T1R มาออกแบบร่วมกันเป็นดอกลายดอกยางแบบไม่สมมาตรที่เป็นเอกลักษณ์โฉบเฉี่ยวไม่ซ้ำใคร เพื่อการควบคุมที่สมบูรณ์แบบบนทุกพื้นผิว \r\r\nและครั้งแรกของยางรถยนต์กับเทคโนโลยี\r\r\nTIRE WEAR INDICATOR ที่สามารถเช็คได้ว่าเมื่อไหร่ถึงเวลา\r\r\nที่ควรเปลี่ยนยางรถยนต์ครั้งต่อไป</p>\r\r\n  </figcaption>\r\r\n</figure>\r\r\n</div>',
        tire_width: 192,
        tire_height: 40,
        tire_size: 17,
        attr_brand: 'NANKANG TIRE',
        attr_model: 'AS-1',
        attr_type: 'LT',
        attr_road: 'ผิวถนนแห้งและผิวถนนเปียก',
        attr_position: 'ขวาหน้า, ซ้ายหน้า, ขวาหลัง, ซ้ายหลัง',
        attr_range: '20000',
        attr_extra_a: 'Traction Groove Edge',
        attr_extra_b: 'High Stiffness Outer Rib',
        attr_extra_c: 'Shallow',
        perf_a: 8,
        perf_b: 10,
        perf_c: 8,
        perf_d: 8,
        perf_e: 8,
        perf_f: 8,
        block_content_a_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-04_result-20250114194830.webp',
        block_content_a_title: 'ร่องตรงรีดน้ำขนาดใหญ่ 4 ร่อง',
        block_content_a_info:
          'เพิ่มการระบายน้ำออกจากหน้ายาง\r\r\nได้อย่างรวดเร็ว ทำให้ประสิทธิภาพบน\r\r\nถนนนเปียกดียิ่งขึ้น',
        block_content_b_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-05-20250108171225.png',
        block_content_b_title: 'ร่องดอกยางขนาดเล็ก',
        block_content_b_info: 'เพิ่มความนุ่มนวลขณะขับขี่จากการวางตำแหน่งร่องยางที่เหมาะสม',
        block_content_c_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-06-20250108171233.png',
        block_content_c_title: 'ร่องดอกยางแบบเกลียว',
        block_content_c_info:
          'ป้องกันการสึกหรอผิดปกติ โดยรักษาผิวสัมผัสของหน้ายาง ให้สัมผัสในระดับเดียวกัน ตลอดทั้งเส้นในขณะรถวิ่งและเบรก',
        block_content_d_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-04_result-20250114194833.webp',
        block_content_d_title: 'ร่องตรงรีดน้ำขนาดใหญ่ 4 ร่อง',
        block_content_d_info:
          'เพิ่มการระบายน้ำออกจากหน้ายาง\r\r\nได้อย่างรวดเร็ว ทำให้ประสิทธิภาพบน\r\r\nถนนนเปียกดียิ่งขึ้น',
        block_content_e_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-05-20250108171245.png',
        block_content_e_title: 'ร่องดอกยางขนาดเล็ก',
        block_content_e_info: 'เพิ่มความนุ่มนวลขณะขับขี่จากการวางตำแหน่งร่องยางที่เหมาะสม',
        block_content_f_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-06-20250108171251.png',
        block_content_f_title: 'ร่องดอกยางแบบเกลียว',
        block_content_f_info:
          'ป้องกันการสึกหรอผิดปกติ โดยรักษาผิวสัมผัสของหน้ายาง ให้สัมผัสในระดับเดียวกัน ตลอดทั้งเส้นในขณะรถวิ่งและเบรก',
        image_a: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/nk1-20241225140920.png',
        image_b: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/pxsp2_right2-%281%29-20250110092651.png',
        image_c: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/pxsp2_front2-%281%29-20250110092712.png',
        image_d: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/pxsp2_left-%281%29-20250110092719.png',
        image_e: null,
        attr_product_a: null,
        attr_product_b: 'NANKANG TIRE',
        attr_product_c: 'AS-1',
        attr_product_d: null,
        attr_product_e: null,
        attr_product_f: null,
        attr_product_g: null,
        attr_product_h: null,
        attr_product_i: null,
        attr_product_j: null,
        brand_name: 'NANKANG TIRE',
        brand_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/352055214_648286097345606_2032769928131087426_n-20250111162736.png',
        urlImgMain: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/nk1-20241225140920.png',
        nameProduct: 'AS-1',
        gripWetRoad: 8,
        gripDryRoad: 10,
        balanceControl: 8,
        comfortable: 8,
        silence: 8,
        preciseCornering: 8,
      },
    ],
  });

  openDetailProduct(event: any) {
    this.emitProductId.emit(event);
  }

  addToComparison(event: any) {
    this.emitComparison.emit(event);
  }
}
